module.exports = __webpack_public_path__ + "img/Wp_2018.0e4f2233.png";